import { autoinject } from "aurelia-framework";

/**
 * Represents the skeleton of a card, which can
 * be used as a placeholder while loading.
 */
@autoinject
export class CardSkeletonCustomElement
{
}
